import {ModalComponentProps, Card, Block, Dialog, DialogBody, DialogFooter, Button, VF, Yup, makeValidate} from '@mc/ui-v4';

import {rffFormSubmit} from '@mc/react-app-v4';
import {Form} from 'react-final-form';
import React, {MutableRefObject} from 'react';
import {useQueryClient} from 'react-query';
import {LayerSettingsApi, TopicBaseVO} from '../../../api';
import {CACHE_KEY_TOPICS_MAP} from '../../../hooks/useTopicsMap';
import {CACHE_KEY_LAYER_TOPIC, CACHE_KEY_TOPICS_OWNED} from '../../../queryKeys';
import {MapEditorActions} from '@mc/react-mapio';
type Props = ModalComponentProps & {
    topicId?: string;
    initData?: TopicBaseVO;
    setTopicId?: (id: string) => void;
    mapRef: MutableRefObject<MapEditorActions>;
};

export const NewEditTopic: React.FC<Props> = ({onClose, topicId, initData, setTopicId, mapRef}) => {
    const validateSchema = Yup.object().shape({
        nazev: Yup.string().required(''),
    });
    const validation = makeValidate(validateSchema);
    const queryClient = useQueryClient();

    return (
        <Form<TopicBaseVO>
            initialValues={initData}
            validate={async data => {
                const errors = await validation(data);
                return errors;
            }}
            onSubmit={async data => {
                return await rffFormSubmit(async () => {
                    let newId: string;
                    if (topicId) {
                        await LayerSettingsApi.updateTopic(topicId, data);
                        await Promise.all([
                            queryClient.invalidateQueries([CACHE_KEY_TOPICS_MAP]),
                            queryClient.invalidateQueries([CACHE_KEY_LAYER_TOPIC, topicId]),
                        ]);
                    } else {
                        newId = (await LayerSettingsApi.createTopic(data)).data;
                        // Zakladatel se na serveru stává vlastníkem tématu - bez znovunačtení vlastněných témat
                        // by správa témat vyhodnotila nové téma jako téma bez práv a přepnula zpět (MCW-29126).
                        await Promise.all([
                            queryClient.invalidateQueries([CACHE_KEY_TOPICS_MAP]),
                            queryClient.invalidateQueries([CACHE_KEY_TOPICS_OWNED]),
                        ]);
                        setTopicId(newId);
                    }
                    mapRef.current.updateTopic(topicId ?? newId);
                    onClose();
                });
            }}
        >
            {({handleSubmit, submitting}) => {
                return (
                    <Dialog size={'md'} onClose={onClose} title={topicId ? 'Úprava tématu' : 'Nové téma'}>
                        <DialogBody>
                            <Card mode={'edit'}>
                                <Block>
                                    <VF.String name={'nazev'} label={'Název tématu'} />
                                </Block>
                            </Card>
                        </DialogBody>
                        <DialogFooter>
                            <Button disabled={submitting} style={'link'} onClick={onClose}>
                                Zrušit
                            </Button>
                            <Button style={'primary'} disabled={submitting} onClick={handleSubmit}>
                                {topicId ? 'Uložit' : 'Vytvořit'}
                            </Button>
                        </DialogFooter>
                    </Dialog>
                );
            }}
        </Form>
    );
};
